import { theme } from '@squire/ui';

/**
 * Horizontal gap between the viewport edge and the centred content column.
 *
 * `Page` caps its content at the `tablet` breakpoint and centres it, so on a
 * viewport wider than that there is dead space either side. Overlays that the
 * platform positions against the viewport use this to line themselves up with
 * the column instead of bleeding to the screen edges.
 *
 * Returns 0 below the breakpoint, where the column already fills the viewport.
 */
export const getContentColumnInset = (windowWidth: number): number =>
  Math.max(0, (windowWidth - theme.breakpoints.tablet) / 2);
